import { render, staticRenderFns } from "./DialogNew.vue?vue&type=template&id=d16d60c0&scoped=true&"
import script from "./DialogNew.vue?vue&type=script&lang=js&"
export * from "./DialogNew.vue?vue&type=script&lang=js&"
import style0 from "./DialogNew.vue?vue&type=style&index=0&id=d16d60c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16d60c0",
  null
  
)

export default component.exports